import {LOCALSTORAGE_ITEMS_AMOUNT_THRESHOLD} from "../../config";

type Storage = Record<string, StorageRecord>

type StorageRecord = {
    state: boolean;
    timestamp: number;
}

export class TmpLikeHelper {
    public LS_CLIPS_KEY = "clipsfs";

    setLike(movieId: number, state: boolean) {
        try {
            const raw = localStorage.getItem(this.LS_CLIPS_KEY);
            let parse: Storage = {};

            if (raw) {
                parse = JSON.parse(raw);
            }

            const storageLength = Object.keys(parse).length;

            parse[movieId] = {
                state: state,
                timestamp: Date.now()
            };

            if (storageLength > LOCALSTORAGE_ITEMS_AMOUNT_THRESHOLD) {
                parse = this.removeHalf(parse);
            }
            localStorage.setItem(this.LS_CLIPS_KEY, JSON.stringify(parse));
        } catch (e) {
            if (window.DEVMODE) {
                // eslint-disable-next-line
                console.error("[clipsFullscreen]: Error set like in LS", e);
            }

        }
    }

    getLike(movieId: number) {
        try {
            const raw = localStorage.getItem(this.LS_CLIPS_KEY);
            let parse: Storage = {};

            if (raw) {
                parse = JSON.parse(raw);

                const item = parse[movieId];

                if (item) {
                    return item.state;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } catch (e) {
            if (window.DEVMODE) {
                // eslint-disable-next-line
                console.error("[clipsFullscreen]: Error get like from LS", e);
            }
        }
    }

    removeHalf(storage: Storage) {
        let sum = 0;
        for (let record in storage) {
            if (storage.hasOwnProperty(record)) {
                sum += storage[record].timestamp;
            }
        }
        sum = sum / Object.keys(storage).length;


        let result: Storage = {};

        for (let record in storage) {
            if (storage.hasOwnProperty(record)) {
                let item = storage[record];

                if (item.timestamp > sum) {
                    result[record] = item;
                }
            }
        }

        return result;
    }
}
